// removed by extract-text-webpack-plugin
module.exports = {"accordeon":"oDjBx7lP9KqEDNPPZ4qdq","expandedAccordeon":"BHckNAyiEF-20MySLZGpJ","accordeonSubTitle":"_1fM6MphKfQ4EtPal3Occhq","triangleContainer":"bk5zInrwL4Al0eCCFKsOv","accordeonLabel":"_3cAw9A353aut3tqM7E9VeR","title":"_1H4nORsV6Z046t6C2U6gZH","whiteTitle":"YQg86FvqhOYjztLrHjig9","triangleRight":"JZpzwscLxqPGhHantyKh6","triangleDown":"_1gnvCCIhYB6yTG8LFsJiGz","triangleRightSub":"_3ThnH-MjuXapAEZUprBy0b","triangleDownSub":"_1zUIJrNPdVK-pq0KFMxnBW","closed":"_2SR_TszdTXgrBs81_jlADl"};


//////////////////
// WEBPACK FOOTER
// ./src/ui-modules/sports-book/css/accordion.css
// module id = 720
// module chunks = 0